"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var L = require("leaflet");
var React = require("react");
var react_dom_1 = require("react-dom");
var RL = require("react-leaflet");
var control = L.Control.extend({
    onAdd: function () {
        return this.options.el;
    },
});
/**
 * The Portal component renders React portal to leaflet control panel.
 */
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        var position = props.position;
        _this.el = L.DomUtil.create("div", props.className);
        _this.leafletElement = new control({ position: position, el: _this.el });
        return _this;
    }
    Portal.prototype.componentDidMount = function () {
        this.leafletElement.addTo(this.props.leaflet.map);
    };
    Portal.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, position = _a.position, className = _a.className;
        if (position !== prevProps.position) {
            this.leafletElement.setPosition(position);
        }
        if (className !== prevProps.className) {
            if (prevProps.className) {
                L.DomUtil.removeClass(this.el, prevProps.className);
            }
            if (className) {
                L.DomUtil.addClass(this.el, className);
            }
        }
    };
    Portal.prototype.render = function () {
        var children = this.props.children;
        return react_dom_1.createPortal(children, this.el);
    };
    return Portal;
}(React.Component));
exports.PortalNoLeaflet = Portal;
exports.default = RL.withLeaflet(Portal);
//# sourceMappingURL=Portal.js.map